import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../assets/css/auth.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { loginWithEmail, loginWithGoogle, user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Redirect if already logged in, but not from registration
  useEffect(() => {
    if (user && !authLoading && !location.state?.fromRegistration) {
      console.log('User is logged in, redirecting to dashboard');
      navigate('/dashboard');
    }
  }, [user, authLoading, navigate, location]);

  // E-Mail/Passwort-Login
  const handleEmailLogin = async (e) => {
    e.preventDefault();
    if (loading) return;
    
    setError('');
    setLoading(true);
    console.log('Starting login process...');

    try {
      const result = await loginWithEmail(email, password);
      console.log('Login result:', result);
      
      if (result.success) {
        console.log('Login successful, navigating to dashboard...');
        navigate('/dashboard', { replace: true });
      } else {
        console.log('Login failed:', result);
        setError(result.message || result.error || 'Anmeldung fehlgeschlagen');
      }
    } catch (error) {
      console.error('Login error:', error);
      if (error.code === 'auth/unverified-email') {
        setError('Bitte bestätigen Sie zuerst Ihre E-Mail-Adresse. Eine neue Bestätigungs-E-Mail wurde gesendet.');
      } else {
        setError(error.message || 'Anmeldung fehlgeschlagen');
      }
    } finally {
      setLoading(false);
    }
  };

  // Google-Login
  const handleGoogleLogin = async () => {
    if (loading) return;
    
    setError('');
    setLoading(true);

    try {
      const result = await loginWithGoogle();
      if (!result.success) {
        setError(result.message || result.error || 'Anmeldung fehlgeschlagen');
      }
    } catch (error) {
      console.error('Google login error:', error);
      setError(error.message || 'Anmeldung fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  // Wenn die Seite noch lädt, zeige nichts an
  if (authLoading) {
    return null;
  }

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-box">
          <div className="auth-header">
            <div className="auth-logo-placeholder">
              <img src="assets/images/Logo3-01.png" alt="Hof-Portal Logo" />
            </div>
            <h1>Direkterzeuger-Portal</h1>
          </div>

          <div className="auth-methods">
            <button 
              id="googleLogin" 
              className="auth-button google"
              onClick={handleGoogleLogin}
              disabled={loading}
            >
              <span className="google-icon">G</span>
              Mit Google anmelden
            </button>

            <div className="divider">oder</div>

            <form id="loginForm" className="auth-form" onSubmit={handleEmailLogin}>
              <div className="form-group">
                <label htmlFor="email">E-Mail</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required 
                  placeholder="Ihre E-Mail-Adresse"
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Passwort</label>
                <input 
                  type="password" 
                  id="password" 
                  name="password" 
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required 
                  placeholder="Ihr Passwort"
                />
              </div>

              {error && (
                <div className="error-message">
                  <i className="fas fa-exclamation-circle"></i>
                  {error}
                </div>
              )}

              <button 
                type="submit" 
                className="auth-button primary"
                disabled={loading}
              >
                {loading ? 'Anmeldung läuft...' : 'Anmelden'}
              </button>

              <div className="auth-footer">
                <p>
                  <Link to="/forgot-password">Passwort vergessen?</Link>
                </p>
                <p>Noch kein Konto? <Link to="/register">Registrieren</Link></p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login; 